import clsx from 'clsx';

import {LinkCard} from '@/components/content-blocks/link-list-selection/link-card';
import type {LinkListSelectionFragment} from '@/components/content-blocks/link-list-selection/query';

type Props = {
	linkItems: LinkListSelectionFragment['linkItems'];
	headingLevel?: 2 | 3;
};

export const GridDetails = ({linkItems, headingLevel}: Props) => {
	if (!linkItems?.length) {
		return null;
	}

	const firstLinkItem = linkItems[0];
	const remainingLinkItems = linkItems.slice(1);

	// If we get an uneven number of links, we want the first one to span two
	// columns, on the xs size:
	const firstShouldSpanTwoColumns = linkItems.length % 2;

	return (
		<div
			className={clsx(
				'grid',
				'grid-cols-2',
				'md:grid-cols-[repeat(auto-fill,_minmax(min(350px,_100%),_1fr))]',
				'gap-4',
				'md:gap-8',
				'ml-auto',
				'mr-auto',
			)}
			// style={{
			// 	maxWidth: linkItems.length < 5 ? `${466 * linkItems.length}px` : 'none',
			// }}
		>
			<LinkCard
				linkItem={firstLinkItem}
				className={clsx(
					firstShouldSpanTwoColumns ? 'max-md:col-span-2' : 'col-span-1',
					'md:hidden',
				)}
				forceAspectRatio={firstShouldSpanTwoColumns ? '4/3' : undefined}
				headingLevel={headingLevel}
			/>
			<LinkCard
				linkItem={firstLinkItem}
				className={clsx('col-span-1', 'max-md:hidden')}
				forceAspectRatio={firstShouldSpanTwoColumns ? '16/9' : undefined}
				headingLevel={headingLevel}
			/>
			{remainingLinkItems.map((linkItem) => (
				<LinkCard key={linkItem._key} linkItem={linkItem} headingLevel={headingLevel} />
			))}
		</div>
	);
};
